define.alias("shared/components/shared/post/secondary/toggle", "settings/components/shared/post/secondary/toggle");